import React from 'react';
import { TriggerProps, useInitiateMatchTriggers } from 'src/feature-app';
import { MatchProspectForm } from 'src/forms';

export function ProspectEmbeddedTrigger({ setSelectedJourney }: TriggerProps): JSX.Element {
  useInitiateMatchTriggers(setSelectedJourney, <MatchProspectForm />);

  return null;
}
